import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { NavBarComponent } from "./nav-bar.component";
import { OnlineStatusModule } from "../../modules-other/online-status/online-status.module";
import { IonicModule } from "ionic-angular";
import { UserPopoverButtonModule } from "../../modules-other/user-popover-button/user-popover-button.module";
import { MoreButtonsPickerModule } from "./more-buttons-picker/more-buttons-picker.module";
import { CalendarButtonModule } from "../calendar-button/calendar-button.module";
import { SyncManagerButtonModule } from "../../modules-other/sync-manager-button/sync-manager-button.module";
import { TaskListButtonModule } from "../task-list-button/task-list-button.module";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        IonicModule,
        OnlineStatusModule,
        UserPopoverButtonModule,
        MoreButtonsPickerModule,
        CalendarButtonModule,
        SyncManagerButtonModule,
        TaskListButtonModule
    ],
    declarations: [
        NavBarComponent
    ],
    exports: [
        NavBarComponent
    ]
})
export class NavBarModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/nav-bar/nav-bar.module.ts